<app-navigation></app-navigation>

<app-api-offline-message *ngIf="!serverOnline"></app-api-offline-message>

<router-outlet></router-outlet>
<span class="version-tag">{{ version }}</span>
